

export const state = {

  monitoring: {
    variables: {
      itemSelected: { id: 'totR', unit: 'in', layer: 1, threshold: '1', title: 'Total Precipitation' },
      items: [{
        action: 'fas fa-cloud-showers-heavy',
        items: [
          { id: 'totR', unit: 'in', layer: 1, threshold: '1', title: 'Total Precipitation' }
        ],
        title: 'Precipitation',
      }, {
        action: 'fas fa-temperature-low',
        items: [
          { id: 'minT', unit: 'f', layer: 1, threshold: '1', title: 'Minimum Temperature' },
          { id: 'avgT', unit: 'f', layer: 1, threshold: '1', title: 'Average Temperature' },
          { id: 'maxT', unit: 'f', layer: 1, threshold: '1', title: 'Maximum Temperature' },
        ],
        title: 'Air Temperature',
      },
      {
        action: 'fas fa-thermometer',
        items: [
          { id: 'hi', unit: 'f', layer: 1, threshold: '1', title: 'Heat Index Average' },
          { id: 'hiAbvCaution', unit: 'hours', layer: 1, threshold: '1', title: 'Hours HI ≥ 80°F (≥ Caution)' },
          { id: 'hiAbvExtremeCaution', unit: 'hours', layer: 1, threshold: '1', title: 'Hours HI ≥ 90°F (≥Extreme Caution)' },
          { id: 'hiAbvDanger', unit: 'hours', layer: 1, threshold: '1', title: 'Hours HI ≥ 103°F (≥Danger)' },
          { id: 'hiAbvExtremeDanger', unit: 'hours', layer: 1, threshold: '1', title: 'Hours HI ≥ 125°F (≥Extreme Danger)' },
        ],
        title: 'Heat Index',
      },
      {
        action: 'fas fa-tint',
        items: [
          { id: 'arid', unit: 'arid', layer: 1, threshold: '1', title: 'Average ARID' }
        ],
        title: 'Drought Index',
      },
      {
        action: 'fas fa-burn',
        items: [
          //{ id: 'kdd', unit: 'f', layer: 1, threshold: 82, title: 'Maximum Temperature > 82ºF' },
          { id: 'kdd', unit: '', layer: 2, threshold: 86, title: 'Stress Degree Days (86ºF)' },
          { id: 'kdd', unit: '', layer: 3, threshold: 90, title: 'Stress Degree Days (90ºF)' },
          { id: 'kdd', unit: '', layer: 4, threshold: 93, title: 'Stress Degree Days (93ºF)' },
          { id: 'kdd', unit: '', layer: 5, threshold: 97, title: 'Stress Degree Days (97ºF)' },
        ],
        title: 'Heat Stress',
      },
      // {
      //   action: 'fas fa-seedling',
      //   items: [
      //     { id: 'gdd', unit: '', layer: 3, threshold: 40, title: 'Growing Degree Day (40ºF)' },
      //     { id: 'gdd', unit: '', layer: 2, threshold: 50, title: 'Growing Degree Day (50ºF)' },
      //     { id: 'gdd', unit: '', layer: 1, threshold: 60, title: 'Growing Degree Day (60ºF)' }
      //   ],
      //   title: 'Growing Degree Days',
      // },
        {
          action: 'far fa-snowflake',
          items: [
            { id: 'chillH', unit: '', layer: 1, threshold: '1', title: 'Chill Hours (32ºF - 45ºF)' },
          ],
          title: 'Chill Accumulation',
        },
        {
          action: 'fa-solid fa-leaf',
          items: [
            { id: 'lwt', unit: '', layer: 1, threshold: [32, 45], title: 'Leaf Wetness' },
          ],
          title: 'Leaf Wetness',
        }
      ]
    },
    timePeriods: {
      itemSelected: '30',
      options: [{ id: '0', description: 'Last Day' }, { id: '2', description: '2 Days' }, { id: '3', description: '3 Days' }, { id: '7', description: '7 Days' }, { id: '15', description: '15 Days' }, { id: '30', description: '30 Days' }, { id: '45', description: '45 Days' }, { id: '60', description: '60 Days' }, { id: '90', description: '90 Days' }, { id: '120', description: '120 Days' }, { id: '150', description: '150 Days' }]
    },
  },

  categories: [
    {
      id: 'physical',
      description: 'Physical'
    }, {
      id: 'phenology',
      description: 'Phenological'
    }, {
      id: 'temperature',
      description: 'Stress'
    }
  ],

  variables: {
    totR: {
      type: 'observed',
      dataObservation: 'daily',
      round: 2,
      isShowThreshold: false,
      isShowAccumulate: true,
      operation: 'sum',
      description: 'Total Precipitation (in)',
      threshold: {
        required: false,
        default: 0
      },
      unit: 'in',
      viewMode: {
        default: 'chart',
        defaultView: true
      },
      chart: {
        axis: 'y1',
        default: 'bar',
        line: {
          color: '#1E88E5',
          width: 3
        }
      },
      category: 'physical'
    },
    totRHis: {
      type: 'observed',
      dataObservation: 'daily',
      round: 2,
      isShowThreshold: false,
      isShowAccumulate: true,
      operation: 'sum',
      description: 'Total Precipitation (in) - Long Term Average',
      threshold: {
        required: false,
        default: 0
      },
      unit: 'in',
      viewMode: {
        default: 'chart',
        defaultView: true
      },
      chart: {
        axis: 'y1',
        default: 'bar',
        line: {
          color: '#90CAF9',
          width: 3
        }
      },
      category: 'physical'
    },
    minT: {
      type: 'observed',
      dataObservation: 'daily',
      round: 1,
      isShowThreshold: false,
      isShowAccumulate: false,
      operation: 'sum',
      description: 'Minimum Temperature (°F)',
      threshold: {
        required: false,
        default: 0
      },
      unit: '°F',
      viewMode: {
        default: 'chart',
        defaultView: true
      },
      chart: {
        axis: 'y2',
        default: 'scatter',
        line: {
          color: '#0288D1',
          width: 3
        }
      },
      category: 'physical'
    },
    minTHis: {
      type: 'observed',
      dataObservation: 'daily',
      round: 1,
      isShowThreshold: false,
      isShowAccumulate: false,
      operation: 'sum',
      description: 'Minimum Temperature (°F) - Long Term Average',
      threshold: {
        required: false,
        default: 0
      },
      unit: '°F',
      viewMode: {
        default: 'chart',
        defaultView: true
      },
      chart: {
        axis: 'y2',
        default: 'scatter',
        line: {
          color: '#81D4FA',
          width: 3
        }
      },
      category: 'physical'
    },
    maxT: {
      type: 'observed',
      dataObservation: 'daily',
      round: 1,
      isShowThreshold: false,
      isShowAccumulate: false,
      operation: 'sum',
      description: 'Maximum Temperature (°F)',
      threshold: {
        required: false,
        default: 0
      },
      unit: '°F',
      viewMode: {
        default: 'chart',
        defaultView: true
      },
      chart: {
        default: 'scatter',
        axis: 'y2',
        line: {
          color: '#D32F2F',
          width: 3
        }
      },
      category: 'physical'
    },
    maxTHis: {
      type: 'observed',
      dataObservation: 'daily',
      round: 1,
      isShowThreshold: false,
      isShowAccumulate: false,
      operation: 'sum',
      description: 'Maximum Temperature (°F) - Long Term Average',
      threshold: {
        required: false,
        default: 0
      },
      unit: '°F',
      viewMode: {
        default: 'chart',
        defaultView: true
      },
      chart: {
        default: 'scatter',
        axis: 'y2',
        line: {
          color: '#EF9A9A',
          width: 3
        }
      },
      category: {
        id: 'physical',
        description: 'Weather'
      }
    },
    avgT: {
      type: 'observed',
      dataObservation: 'daily',
      round: 1,
      isShowThreshold: false,
      isShowAccumulate: false,
      operation: 'sum',
      description: 'Average Temperature (°F)',
      unit: '°F',
      threshold: {
        required: false,
        default: 0
      },
      viewMode: {
        default: 'chart',
        defaultView: true
      },
      chart: {
        axis: 'y2',
        default: 'scatter',
        line: {
          color: '#F57C00',
          width: 3
        }
      },
      category: 'physical'
    },
    avgTHis: {
      type: 'observed',
      dataObservation: 'daily',
      round: 1,
      isShowThreshold: false,
      isShowAccumulate: false,
      operation: 'sum',
      description: 'Average Temperature (°F) - Long Term Average',
      unit: '°F',
      threshold: {
        required: false,
        default: 0
      },
      viewMode: {
        default: 'chart',
        defaultView: true
      },
      chart: {
        axis: 'y2',
        default: 'scatter',
        line: {
          color: '#FFCC80',
          width: 3
        }
      },
      category: {
        id: 'physical',
        description: 'Weather'
      }
    },
    'chillH': {
      type: 'model',
      dataObservation: 'hourly',
      round: 2,
      isShowThreshold: true,
      isShowAccumulate: true,
      operation: 'sum',
      description: 'Chill Hours',
      threshold: {
        required: true,
        default: [32, 45]
      },
      unit: '',
      viewMode: {
        default: 'chart',
        defaultView: true
      },
      chart: {
        axis: 'y3',
        default: 'scatter',
        line: {
          color: '#4CAF50',
          width: 3
        }
      },
      category: 'phenology'
    },
    'chillHHis': {
      type: 'model',
      dataObservation: 'hourly',
      round: 2,
      isShowThreshold: true,
      isShowAccumulate: true,
      operation: 'sum',
      description: 'Chill Hours - Long Term Average',
      threshold: {
        required: true,
        default: [32, 45]
      },
      unit: '',
      viewMode: {
        default: 'chart',
        defaultView: true
      },
      chart: {
        axis: 'y3',
        default: 'scatter',
        line: {
          color: '#A5D6A7',
          width: 3
        }
      },
      category: 'phenology'
    },
    chillP: {
      type: 'model',
      dataObservation: 'hourly',
      round: 2,
      isShowThreshold: false,
      isShowAccumulate: true,
      operation: 'sum',
      description: 'Chill Portions',
      unit: '',
      threshold: {
        required: false,
        default: 0
      },
      viewMode: {
        default: 'chart',
        defaultView: true
      },
      chart: {
        axis: 'y3',
        default: 'scatter',
        line: {
          color: '#2E7D32',
          width: 3
        }
      },
      category: 'phenology'
    },
    // 'chill-units': {
    //   type: 'model',
    //   dataObservation: 'hourly',
    //   round: 2,
    //   isShowThreshold: false,
    //   isShowAccumulate: true,
    //   operation: 'sum',
    //   description: 'Chill Units',
    //   unit: '',
    //   threshold: {
    //     required: false,
    //     default: 0
    //   },
    //   viewMode: {
    //     default: 'chart',
    //     defaultView: true
    //   },
    //   chart: {
    //     axis: 'y3',
    //     default: 'scatter',
    //     line: {
    //       color: '#388E3C',
    //       width: 3
    //     }
    //   },
    //   category: 'phenology'
    // },
    // 'chill-unitsHis': {
    //   type: 'model',
    //   dataObservation: 'hourly',
    //   round: 2,
    //   isShowThreshold: false,
    //   isShowAccumulate: true,
    //   operation: 'sum',
    //   description: 'Chill Units - Long Term Average',
    //   unit: '',
    //   threshold: {
    //     required: false,
    //     default: 0
    //   },
    //   viewMode: {
    //     default: 'chart',
    //     defaultView: true
    //   },
    //   chart: {
    //     axis: 'y3',
    //     default: 'scatter',
    //     line: {
    //       color: '#81C784',
    //       width: 3
    //     }
    //   },
    //   category: 'phenology'
    // },
    chillU: {
      type: 'model',
      dataObservation: 'hourly',
      round: 2,
      isShowThreshold: false,
      isShowAccumulate: true,
      operation: 'sum',
      description: 'Chill Units',
      unit: '',
      threshold: {
        required: false,
        default: 0
      },
      viewMode: {
        default: 'chart',
        defaultView: true
      },
      chart: {
        axis: 'y3',
        default: 'scatter',
        line: {
          color: '#388E3C',
          width: 3
        }
      },
      category: 'phenology'
    },
    chillUHis: {
      type: 'model',
      dataObservation: 'hourly',
      round: 2,
      isShowThreshold: false,
      isShowAccumulate: true,
      operation: 'sum',
      description: 'Chill Units - Long Term Average',
      unit: '',
      threshold: {
        required: false,
        default: 0
      },
      viewMode: {
        default: 'chart',
        defaultView: true
      },
      chart: {
        axis: 'y3',
        default: 'scatter',
        line: {
          color: '#81C784',
          width: 3
        }
      },
      category: 'phenology'
    },
    'hi': {
      type: 'model',
      dataObservation: 'hourly',
      round: 2,
      isShowThreshold: false,
      isShowAccumulate: false,
      operation: 'sum',
      description: 'Heat Index',
      threshold: {
        required: false,
        default: 0
      },
      unit: '',
      viewMode: {
        default: 'chart',
        defaultView: true
      },
      chart: {
        axis: 'y3',
        default: 'scatter',
        line: {
          color: '#FE05CD',
          width: 3
        }
      },
      category: 'temperature'
    },
    'hiHis': {
      type: 'model',
      dataObservation: 'hourly',
      round: 2,
      isShowThreshold: false,
      isShowAccumulate: false,
      operation: 'sum',
      description: 'HI - Long Term Average',
      threshold: {
        required: false,
        default: 0
      },
      unit: '',
      viewMode: {
        default: 'chart',
        defaultView: true
      },
      chart: {
        axis: 'y3',
        default: 'scatter',
        line: {
          color: '#fe05cceb',
          width: 3
        }
      },
      category: 'temperature'
    },
    'thi': {
      type: 'model',
      dataObservation: 'hourly',
      round: 2,
      isShowThreshold: false,
      isShowAccumulate: true,
      operation: 'sum',
      description: 'Temperature-Humidity Index',
      threshold: {
        required: false,
        default: 0
      },
      unit: '',
      viewMode: {
        default: 'chart',
        defaultView: true
      },
      chart: {
        axis: 'y3',
        default: 'scatter',
        line: {
          color: '#FF7043',
          width: 3
        }
      },
      category: 'temperature'
    },
    'thiHis': {
      type: 'model',
      dataObservation: 'hourly',
      round: 2,
      isShowThreshold: false,
      isShowAccumulate: true,
      operation: 'sum',
      description: 'THI - Long Term Average',
      threshold: {
        required: false,
        default: 0
      },
      unit: '',
      viewMode: {
        default: 'chart',
        defaultView: true
      },
      chart: {
        axis: 'y3',
        default: 'scatter',
        line: {
          color: '#FFAB91',
          width: 3
        }
      },
      category: 'temperature'
    },
    'drySpell': {
      type: 'model',
      dataObservation: 'daily',
      round: 1,
      isShowThreshold: false,
      isShowAccumulate: true,
      operation: 'sum',
      description: 'Longest Dry Spell (Number of days)',
      viewMode: {
        default: 'panel',
        defaultView: true
      },
      threshold: {
        required: false,
        default: 0
      },
      unit: '',
      chart: {
        axis: 'y3',
        default: 'scatter',
        line: {
          color: '#8D6E63',
          width: 3
        }
      },
      category: 'temperature'
    },
    'wetSpell': {
      type: 'model',
      dataObservation: 'daily',
      round: 1,
      isShowThreshold: false,
      isShowAccumulate: true,
      operation: 'sum',
      description: 'Wet Spell (Number of days)',
      threshold: {
        required: false,
        default: 0
      },
      unit: '',
      viewMode: {
        default: 'panel',
        defaultView: true
      },
      chart: {
        defaultView: false,
        axis: 'y3',
        default: 'scatter',
        mode: 'lines+markers',
        line: {
          color: '#4FC3F7',
          width: 3
        }
      },
      category: 'temperature'
    },
    'gdd': {
      type: 'model',
      dataObservation: 'daily',
      round: 0,
      isShowThreshold: true,
      isShowAccumulate: true,
      operation: 'sum',
      description: 'Growing Degree Days',
      threshold: {
        required: true,
        default: [50]
      },
      unit: '',
      viewMode: {
        default: 'chart',
        defaultView: true
      },
      chart: {
        axis: 'y3',
        default: 'scatter',
        mode: 'lines+markers',
        line: {
          color: '#7B1FA2',
          width: 3
        }
      },
      category: 'phenology'
    },
    'gddHis': {
      type: 'model',
      dataObservation: 'daily',
      round: 0,
      isShowThreshold: true,
      isShowAccumulate: true,
      operation: 'sum',
      description: 'Growing Degree Days - Long Term Average',
      threshold: {
        required: true,
        default: [50]
      },
      unit: '',
      viewMode: {
        default: 'chart',
        defaultView: true
      },
      chart: {
        axis: 'y3',
        default: 'scatter',
        mode: 'lines+markers',
        line: {
          color: '#CE93D8',
          width: 3
        }
      },
      category: 'phenology'
    },
    'kdd': {
      type: 'model',
      dataObservation: 'daily',
      round: 0,
      isShowThreshold: true,
      isShowAccumulate: true,
      operation: 'sum',
      description: 'Heat Stress Degree Days',
      threshold: {
        required: true,
        default: [90]
      },
      unit: '',
      viewMode: {
        default: 'chart',
        defaultView: true
      },
      chart: {
        axis: 'y3',
        default: 'scatter',
        mode: 'lines+markers',
        line: {
          color: '#E64A19',
          width: 3
        }
      },
      category: 'temperature'
    },
    'kddHis': {
      type: 'model',
      dataObservation: 'daily',
      round: 0,
      isShowThreshold: true,
      isShowAccumulate: true,
      operation: 'sum',
      description: 'Stress Degree Days - Long Term Average',
      threshold: {
        required: true,
        default: [90]
      },
      unit: '',
      viewMode: {
        default: 'chart',
        defaultView: true
      },
      chart: {
        axis: 'y3',
        default: 'scatter',
        line: {
          color: '#FFAB91',
          width: 3
        }
      },
      category: 'temperature'
    },
    'arid': {
      type: 'model',
      source: 'pixel',
      dataObservation: 'daily',
      round: 2,
      isShowThreshold: false,
      isShowAccumulate: true,
      operation: 'sum',
      description: 'ARID',
      threshold: {
        required: false,
        default: 0
      },
      viewMode: {
        default: 'chart',
        defaultView: true
      },
      chart: {
        axis: 'y4',
        default: 'scatter',
        range: [0, 1],
        line: {
          color: '#F6721D',
          width: 3
        },
      },
      category: 'temperature'
    },
    'lwt': {
      type: 'model',
      source: 'acis',
      dataObservation: 'hourly',
      round: 2,
      isShowThreshold: false,
      isShowAccumulate: true,
      operation: 'sum',
      description: 'Leaf Wetness',
      threshold: {
        required: false,
        default: 0
      },
      viewMode: {
        default: 'chart',
        defaultView: true
      },
      chart: {
        axis: 'y2',
        default: 'scatter',
        range: [0, 1],
        line: {
          color: '#1df6ef',
          width: 2
        },
      },
      category: 'physical'
    },
    'lwtHis': {
      type: 'model',
      source: 'acis',
      dataObservation: 'hourly',
      round: 2,
      isShowThreshold: false,
      isShowAccumulate: true,
      operation: 'sum',
      description: 'Leaf Wetness - Long Term Average',
      threshold: {
        required: false,
        default: 0
      },
      viewMode: {
        default: 'chart',
        defaultView: true
      },
      chart: {
        axis: 'y2',
        default: 'scatter',
        range: [0, 1],
        line: {
          color: '#6e79f7',
          width: 2
        },
      },
      category: 'physical'
    },
  },
};